export const allowedMessageStates = [
  'created',
  'approved',
  'checked',
  'rejected',
  'solved',
  'unsolvable',
  'special',
] as const;

export const allowedMessageStatesGermanText = [
  'Warten auf Freigabe',
  'Ungeprüft',
  'In Bearbeitung',
  'Abgelehnt',
  'Gelöst',
  'Ungelöst Abgeschlossen',
  'Weitergabe an Dritte',
] as const;

export type MessageStateType = (typeof allowedMessageStates)[number];
export type MessageStateGermanTextType = (typeof allowedMessageStatesGermanText)[number];

export const messageStateTypeMappedToGermanText = {
  created: 'Warten auf Freigabe',
  approved: 'Ungeprüft',
  checked: 'In Bearbeitung',
  rejected: 'Abgelehnt',
  solved: 'Gelöst',
  unsolvable: 'Ungelöst Abgeschlossen',
  special: 'Weitergabe an Dritte',
} as const;
// Can't use typescript's satisfies, because pretty-quick is throwing an error
// satisfies Record<MessageStateType, MessageStateGermanTextType>
